export class G2WView {
  constructor(g2wView = {}) {
    this._email = g2wView.email;
    this._givenName = g2wView.givenName;
    this._surName = g2wView.surName;
    this._viewCount = 1;
    this._viewDate = g2wView.viewDate;
  }

  get email() {
    return this._email;
  }

  set email(value) {
    this._email = value;
  }

  get givenName() {
    return this._givenName;
  }

  set givenName(value) {
    this._givenName = value;
  }

  get surName() {
    return this._surName;
  }

  set surName(value) {
    this._surName = value;
  }

  get viewCount() {
    return this._viewCount;
  }

  set viewCount(value) {
    this._viewCount = value;
  }

  get viewDate() {
    return this._viewDate;
  }

  set viewDate(value) {
    this._viewDate = value;
  }
}



// WEBPACK FOOTER //
// ./src/Model/Views/G2WView.js